<script>
import { GlHead } from '~/components';

export default {
  components: {
    GlHead,
  },
};
</script>

<template>
  <div class="gl-relative">
    <transition name="slide">
      <div>
        <gl-head />
        <div class="gl-mx-8 gl-my-9 gl-mt-6">
          <router-view />
        </div>
      </div>
    </transition>
  </div>
</template>
